










































	import { MyActions } from '@/models/Store/State';
	import Vue from 'vue';

    export default Vue.extend({
        name: "DeleteDialogComp",
        data: () => ({
            newTermin: false,
        }),
        methods: {
            deleteOK: function(): void {
                this.$vStore.dispatch(MyActions.Delete, this.newTermin);
            },
            deleteCancel: function(): void {
                this.$vStore.dispatch(MyActions.CloseDialog);
            }
        },
        computed: {
            open: {
                get: function(): any {
                    return this.$vStore.getters.isDialogOpen('delete');
                },
                set: function(): void {
                    this.$vStore.dispatch(MyActions.CloseDialog);
                }
            }
        }
    })
